import { useAtom } from "jotai";

import ButtonGroup, { YES_OR_NO_OPTIONS } from "components/ButtonGroup";
import Text from "components/Text";

import { getQuestionAtom } from "atoms/vehicleCondition/questions";
import { useClientTranslation } from "hooks/useClientTranslation";

import {
  VEHICLE_CONDITION_QUESTION_DESCRIPTION_TRANSLATION_KEYS,
  VEHICLE_CONDITION_TRANSLATION_KEYS,
} from "./constants";
import { VehicleConditionQuestions } from "./types";

type VehicleConditionQuestionProps = {
  variant: keyof VehicleConditionQuestions;
};

export const VehicleConditionQuestion = ({ variant }: VehicleConditionQuestionProps) => {
  const { t } = useClientTranslation();
  const translationKey = VEHICLE_CONDITION_TRANSLATION_KEYS[variant];
  const decsriptionTranslationKey = VEHICLE_CONDITION_QUESTION_DESCRIPTION_TRANSLATION_KEYS[variant];
  const [selected, setSelected] = useAtom(getQuestionAtom(variant));

  return (
    <ButtonGroup
      name={variant}
      value={selected}
      onChange={(value) => setSelected(value as boolean)}
      label={<Text sizeVariant="lg">{t(translationKey)}</Text>}
      description={decsriptionTranslationKey && <Text as="span">{t(decsriptionTranslationKey)}</Text>}
      options={YES_OR_NO_OPTIONS}
    />
  );
};
